import { FormattedMessage } from 'react-intl';
import { People } from '@mui/icons-material';
import { Button, Container, Grid, Typography } from '@mui/material';

const urls = {
  chat: 'https://calendly.com/plooto-demo/plootonetwork',
  signup:
    'https://www.plooto.com/signup?utm_source=portal&utm_medium=invoices_cta&utm_campaign=experiment_1.1&utm_content=variant_b',
};

export const FreeTrialSignupBanner = () => (
  <Container
    className="card-plooto"
    sx={{
      paddingTop: 3,
      paddingBottom: 3,
      marginBottom: 2,
    }}
  >
    <Grid container alignItems="center" rowSpacing={2}>
      <Grid item xs={12} sm={6}>
        <Typography variant="subtitle1">
          <FormattedMessage defaultMessage="Tired of sending invoices manually?" />
        </Typography>
        <Typography variant="body1">
          <FormattedMessage defaultMessage="Explore the benefits of automated receivable workflows with Plooto today." />
        </Typography>
      </Grid>
      <Grid item xs={12} sm={6}>
        <Grid
          container
          columnSpacing={1}
          rowSpacing={1}
          justifyContent="flex-end"
          direction={{ xs: 'column-reverse', sm: 'row' }}
        >
          <Grid item>
            <Button
              href={urls.chat}
              target="_blank"
              rel="noopener"
              startIcon={<People />}
              variant="outlined"
              color="primary"
              sx={{ width: { xs: '100%', sm: 'auto' } }}
            >
              <FormattedMessage defaultMessage="Let's Chat" />
            </Button>
          </Grid>
          <Grid item>
            <Button
              href={urls.signup}
              target="_blank"
              rel="noopener"
              variant="contained"
              color="primary"
              sx={{ width: { xs: '100%', sm: 'auto' } }}
            >
              <FormattedMessage defaultMessage="Get Started For Free" />
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  </Container>
);
